import { createAction, props } from '@ngrx/store';
import { IAsqEmployerItem } from '../models/asq-employers.model';

export const loadAsqEmployers = createAction('[ASQ Employers] Load ASQ Employers');

export const loadAsqEmployersSuccess = createAction(
  '[ASQ Employers] Load ASQ Employers Success',
  props<{ response: IAsqEmployerItem[] }>()
);

export const loadAsqEmployersFailure = createAction(
  '[ASQ Employers] Load ASQ Employers Failure',
  props<{ error: Error | any }>()
);
